import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { cx } from '../cx.js';
import { Button } from './Button.js';

export interface CopyFieldProps {
  label: string;
  value: string;
  testoCopia?: string;
  testoCopiato?: string;
  /** Nasconde il valore (es. chiave) finché non si preme "Mostra". */
  segreto?: boolean;
  testoMostra?: string;
  className?: string;
}

/** Valore tecnico in `code` con il bottone "Copia". */
export function CopyField({ label, value, testoCopia = 'Copia', testoCopiato = 'Copiato', segreto = false, testoMostra = 'Mostra', className }: CopyFieldProps) {
  const [copiato, setCopiato] = useState(false);
  const [visibile, setVisibile] = useState(!segreto);
  async function copia() {
    try {
      await navigator.clipboard.writeText(value);
      setCopiato(true);
      setTimeout(() => setCopiato(false), 2000);
    } catch {
      /* appunti non disponibili: il valore resta leggibile */
    }
  }
  return (
    <div className={cx('flex flex-col gap-1', className)}>
      <span className="t-label text-ink-muted">{label}</span>
      <div className="flex flex-wrap items-center gap-2">
        <code className="t-code bg-surface-sunken rounded-md px-3 py-2 break-all flex-1 min-w-0">{visibile ? value : '•'.repeat(Math.min(24, value.length))}</code>
        {!visibile && (
          <Button variant="discreet" onClick={() => setVisibile(true)}>
            {testoMostra}
          </Button>
        )}
        <Button icon={copiato ? Check : Copy} onClick={copia} aria-live="polite">
          {copiato ? testoCopiato : testoCopia}
        </Button>
      </div>
    </div>
  );
}
